<template>
  <a-modal
    :title="title"
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="产品名称"
            >
              <a-select
                placeholder="请选择"
                v-decorator="['address', validatorRules.address]"
              >
                <a-select-option :value="1">电话</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="资金需求状态"
            >
              <a-select v-decorator="['category', {}]" placeholder="请选择">
                <a-select-option :value="1">电话</a-select-option>
                <a-select-option :value="2">会话</a-select-option>
                <a-select-option :value="3">机器人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="起息日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                v-decorator="['endTime', validatorRules.address]"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="结息日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                v-decorator="['endTime']"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="预取开放日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="申购日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="赎回日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="下一个申购日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="下一个赎回日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="下一个开放日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="发行开始日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              label="发行截止日"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <j-date
                placeholder="请选择"
                dateFormat="YYYY-MM-DD"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="质押备注"
            >
              <a-input placeholder="请选择" :max-length="16" />
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="资金需求"
            >
              <a-input placeholder="请选择" :max-length="16" />
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="8">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="发行天数"
            >
              <a-input placeholder="请输入发行天数" :max-length="16" />
            </a-form-item>
          </a-col>

          <!-- <a-col :md="12" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类别">
              <a-select v-decorator="['category', {}]">
                <a-select-option value="1">电话</a-select-option>
                <a-select-option value="2">会话</a-select-option>
                <a-select-option value="3">机器人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="12" :sm="8"> </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction,jsonAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
export default {
  data() {
    return {
      title: '新增',
      visible: false,
      model: {},
      typeText: '',
      value: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        // id: { rules: [{ required: true, message: '请输入id!' }] },
        // name: { rules: [{ required: true, message: '请输入岗位名称!' }] },
        qualifications: {
          rules: [{ required: true, message: '请输入任职资格!' }]
        },
        postName: { rules: [{ required: true, message: '请输入岗位名称!' }] },
        number: { rules: [{ required: true, message: '请输入招聘人数!' }] },
        address: { rules: [{ required: true, message: '请输入地址!' }] },
        positionDes: {
          rules: [{ required: true, message: '请输入职位描述!' }]
        },
        email: { rules: [{ required: true, message: '请输入投递邮箱!' }] },
        endTime: { rules: [{ required: true, message: '请输入招聘时间!' }] }
      },
      url: {
        add:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productQuotation/add',
        edit:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productQuotation/edit'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'id',
            'fund_code',
            'fund_name',
            'begin_date_str',
            'end_date_str',
            'expected_yield',
            'open_date_str',
            'purchase_date_str',
            'redemption_date_str',
            'next_purchase_date_str',
            'next_redemption_date_str',
            'next_open_date_str',
            'fund_demand_status',
            'issue_begin_date_str',
            'issue_end_date_str',
            'issue_number',
            'due_date_str',
            'pledge_note'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          let formData = Object.assign(this.model, values);
          console.log(this.model);
          //时间格式化
          jsonAction(httpurl, formData, method).then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    }
  }
};
</script>

<style>
.ant-col-sm-5 {
  width: 26%;
}
</style>
